import React, { memo } from "react";
import CheckBox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./assets/styles/chekcboxes.styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useAppDispatch, useAppSelector } from "../app/hooks/reduxHooks";
import { handleChange } from "../app/formSlice";

const useStyles = makeStyles(styles);

function CheckBoxes() {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const firstValue = useAppSelector((state) => state.form.firstCheckBox);
  const secondValue = useAppSelector((state) => state.form.secondCheckBox);
  const setValue = (e) => {
    dispatch(
      handleChange({
        name: e.target.name,
        value: e.target.checked,
      })
    );
  };
  return (
    <div className={classes.root} style={{ cursor: "none" }}>
      <FormControlLabel
        style={{ cursor: "none" }}
        className={classes.noPad}
        control={
          <CheckBox
            name="firstCheckBox"
            checked={firstValue}
            onChange={setValue}
            style={{ cursor: "none" }}
            icon={<span className={classes.checkBoxUncheck}></span>}
            checkedIcon={<span className={classes.checkBoxChecked}></span>}
          />
        }
        label={
          <p className={classes.p}>
            Autorizzo il trattamento dei miei dati al fine di dare seguito alla
            mia richiesta come indicato nell'informativa
          </p>
        }
      />
      <FormControlLabel
        className={classes.noPad}
        control={
          <CheckBox
            name="secondCheckBox"
            checked={secondValue}
            style={{ cursor: "none" }}
            onChange={setValue}
            icon={<span className={classes.checkBoxUncheck}></span>}
            checkedIcon={<span className={classes.checkBoxChecked}></span>}
          />
        }
        label={
          <p className={classes.p}>
            Accetto il trattamento dei miei dati per l’invio di comunicazioni
            promozionali da Refin come indicato nell’informativa
          </p>
        }
      />
      <p className={classes.warn}>
        È possibile modificare le proprie preferenze e disiscriversi in qualsiai
        momento scrivendo a{" "}
        <a className={classes.a} href="https://privacy@refin.it">
          privacy@refin.it
        </a>
      </p>
    </div>
  );
}

export default memo(CheckBoxes);
